import { type LucideIcon } from 'lucide-react';
import { type HTMLAttributes, type ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  ...props
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 border border-dashed border-border p-8 text-center',
        className,
      )}
      {...props}
    >
      {Icon ? <Icon className="h-10 w-10 text-fg-faint" aria-hidden /> : null}
      <h3 className="text-heading-sm text-fg">{title}</h3>
      {description ? <p className="max-w-sm text-body-sm text-fg-muted">{description}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
